// Percorsi e costanti condivise.
//
// BACKEND è il prefisso del backend legacy (FastAPI :8001). Sotto omnisurv.it
// vale "/survmaps" (public/config.js) e nginx toglie il prefisso prima di
// proxare. Le API di OmniSurv invece stanno alla radice dello stesso dominio.

export const BACKEND =
  (typeof window !== "undefined" && window.__BACKEND_URL__) || "";

export const OMNI_AUTH_ME = "/auth/me";
export const OMNI_LOGIN_URL = "/ui_kits/workflow-canvas/";

export const PRG_SELECTOR_URL = "/prgselector/";
export const SURVSOLAR_URL = "/survsolar/";
export const PRIVACY_URL = `${BACKEND}/privacy`;

// "castelfidardo_60022" → "Castelfidardo"
export function cityNameFromKey(key) {
  return (key || "")
    .split("_")
    .filter((w) => w && !/^\d+$/.test(w))
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
